module.exports = __webpack_public_path__ + "static/media/c++.5be9bde4.svg";